import { User } from './user.model';
import { AccessorsMutatorsDecorator } from '../../helpers';

/**
 * @class CreditViewableUser
 */
export class CreditViewableUser extends User {

}

AccessorsMutatorsDecorator(
    'id',
    'name',
    'access',
    'disabled',
)(CreditViewableUser);



// WEBPACK FOOTER //
// ./src/pms-api/models/credit-viewable-user.model.js